import { useDispatch, useSelector } from 'react-redux'
import { setWidgetSizeWideOpen, setWidgetTab, setMessengerTabState } from 'app/redux/widget/widget.actions'
import { BackIcon } from '../icons'
import { useRef, useEffect, useState } from 'react'
import { truncateText } from 'app/utils/text'
import { setActiveDepartment } from 'app/redux/messages/messages.actions'
import { MESSENGER_TAB_STATE } from 'app/constants/launcherContentStates'
import CloseWidgetBtn from '../CloseWidgetBtn'
import { iframeStyles } from 'app/constants/iframeStyles'
import './questionDetail.scss'

const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo
const getSelectedQuestion = ({ messagesData }) => messagesData.selectedQuestion
const getPrevTab = ({ widgetData }) => widgetData.widgetInfo.prevTab
const getDepartments = ({ widgetData }) => widgetData.widgetInfo.data?.teams

const QuestionDetail = () => {
  const dispatch = useDispatch()

  const languageInfo = useSelector(getLanguageInfo)
  const selectedQuestion = useSelector(getSelectedQuestion)
  const prevTab = useSelector(getPrevTab)
  const departments = useSelector(getDepartments)

  const iframeRef = useRef(null)
  const [isLoadingFrame, setIsLoadingFrame] = useState(true)

  const customCssVariables = {
    '--raychat-direction': languageInfo?.general?.direction === 'rtl' ? 'right' : 'left',
  }

  const handleMinimizeWidget = () => {
    dispatch(setWidgetSizeWideOpen(false))
  }

  const handleClickBackBtn = () => {
    handleMinimizeWidget()
    if (prevTab !== null && prevTab === 0) dispatch(setWidgetTab(prevTab))
  }

  const handleSelectMessengerTab = () => {
    dispatch(setWidgetTab(1))
    setTimeout(() => {
      handleMinimizeWidget()
    }, 0)

    if (departments) {
      if (departments.length === 1) {
        const departmentId = departments[0]._id
        dispatch(setActiveDepartment(departmentId))
        dispatch(setMessengerTabState(MESSENGER_TAB_STATE.CHAT))
        return
      }
      dispatch(setMessengerTabState(MESSENGER_TAB_STATE.DEPARTMENTS))
      return
    }
    dispatch(setMessengerTabState(MESSENGER_TAB_STATE.CHAT))
  }

  const handleSelectHelpTab = () => {
    handleMinimizeWidget()
    dispatch(setWidgetTab(2))
  }

  const handleIframeLoad = () => {
    setIsLoadingFrame(false)
    const iframe = iframeRef.current
    if (iframe) {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document

      const iframeBody = iframeDocument.body

      const styleElement = iframeDocument.createElement('style')

      styleElement.innerHTML = iframeStyles

      iframeDocument.head.appendChild(styleElement)

      const bodyStyle = iframeDocument.createElement('style')
      bodyStyle.textContent = `
      html {
        overflow: scroll;
        display: flex;
      }

      body {
          margin: 10px;
      }
  `
      iframeDocument.head.appendChild(bodyStyle)

      if (iframeBody) {
        iframeBody.dir = languageInfo?.general?.direction ?? 'rtl'
      }
    }
  }

  useEffect(() => {
    const iframe = iframeRef.current
    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad)
    }

    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleIframeLoad)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQuestion])

  return (
    <div className="question_page_wrapper" style={customCssVariables}>
      <div className="question_page">
        {/* header */}
        <div className="question_page_header">
          <div className="question_page_header_tabs">
            <div onClick={handleSelectMessengerTab} className="question_page_header_tabs_messenger">
              {languageInfo.texts.messenger}
            </div>
            <div onClick={handleSelectHelpTab} className="question_page_header_tabs_help">
              {languageInfo.texts.knowledgeBase}
            </div>
          </div>

          <div className="question_page_header_icons">
            <CloseWidgetBtn />

            <div onClick={handleClickBackBtn} className="question_page_header_icons_back">
              <BackIcon color={'#ffffff'} />
            </div>
          </div>
        </div>

        {/* title */}
        <div className="question_page_title">{truncateText(selectedQuestion.question, 220)}</div>

        <div className="question_page_content">
          {isLoadingFrame && (
            <div className="question_page_content_loading">{`${languageInfo.texts.receiving}...`}</div>
          )}
          <iframe
            title="question_detail"
            srcDoc={selectedQuestion.answer}
            ref={iframeRef}
            onLoad={() => setIsLoadingFrame(false)}
          />
        </div>
      </div>
    </div>
  )
}

export default QuestionDetail
